import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { CoreDomainService } from '@client/app/core/services/domain/core-domain.service';
import { PagesUsersComponent } from '@client/app/pages/global/users/users.component';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { StateService } from '@uirouter/core';
import {
    MonUIRouterTransitionService,
} from '@monsido/services/ui-router-transition-service/ui-router-transition-service';

@Component({
    selector: 'base-global',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseGlobalComponent {}

export const GLOBAL_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.global',
        url: '',
        abstract: true,
        component: BaseGlobalComponent,
        data: { anonymous_access: false },
        resolve: [
            {
                token: 'removeDomain',
                deps: [CoreDomainService],
                resolveFn: async (
                    ng2CoreDomainService: CoreDomainService,
                ) => {
                    ng2CoreDomainService.clearDomain();
                    ng2CoreDomainService.removeDomainGroup();
                    ng2CoreDomainService.changeDomain();
                },
            },
        ],
    },
    {
        name: 'base.customer.global.users',
        url: '/users',
        views: {
            'content@base.customer.global': {
                component: PagesUsersComponent,
            },
        },
        data: { title: 'Acquia Web Governance - User List' },
        resolve: [{
            token: 'isCustomerAdmin',
            deps: [PipeService, StateService, MonUIRouterTransitionService],
            resolveFn: async (
                ng2PipeService: PipeService,
                $state: StateService,
                ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
            ) => {
                if (!ng2PipeService.get('role')(['customer_admin'])) {
                    return ng2MonUIRouterTransitionService.onTransitionFinished(
                        () => {
                            $state.go('base.dashboard');
                        },
                    );
                }
            },
        }],
    },
];
